import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  ReaderIcon,
  MixIcon,
  CardStackIcon,
  CalendarIcon,
  BoxModelIcon,
} from "@radix-ui/react-icons";

export const Logitech_zoneRoutes = {
  "Logitech G Zone": [
    {
      title: "Logitech G",
      link: `${siteRoutes["zone"]}logitech-g`,
      logo: MixIcon,
    },
    brand.hasFeature.challenges && {
      title: "routes.route.overview",
      link: `${siteRoutes["zone"]}logitech-g${siteRoutes["challenges"]}`,
      logo: MixIcon,
    },
    brand.hasFeature.news && {
      title: "routes.route.news",
      link: `${siteRoutes["zone"]}logitech-g${siteRoutes["news"]}`,
      logo: ReaderIcon,
    },
    {
      title: "routes.route.events",
      link: `${siteRoutes["zone"]}logitech-g${siteRoutes["events"]}`,
      logo: CalendarIcon,
    },
  ],
  "Best Gamer": [
    {
      title: "routes.route.home",
      link: siteRoutes["home"],
      logo: CardStackIcon,
    },
    brand.hasFeature.zones && {
      title: "routes.route.zones",
      link: siteRoutes["zones"],
      logo: BoxModelIcon,
    },
  ],
};
